import React from 'react';
function iframe() {
    return {
        __html: '<iframe src="' + process.env.PUBLIC_URL + '/dangerous_html.html" width="100%" height="400" overflow="hidden" frameBorder="0" scrolling="no" ></iframe>'
    }
}


export default function Footer() {
    return (
        <div>
            <div dangerouslySetInnerHTML={iframe()} />
        </div>)
}